import typeHelper from './typeHelper';

const alowedCharactersRegex = /^[a-zA-Z0-9\s()\-_,.]*$/;
const whiteSpaceRegex = /^\s*$/;

const stringHelper = {
    isEmpty: (value: string) => typeHelper.isString(value) && whiteSpaceRegex.test(value),
    isNonEmpty: (value: string) => typeHelper.isString(value) && !whiteSpaceRegex.test(value),
    containsNotAllowedCharacters: (value: string) => !alowedCharactersRegex.test(value),
    firstLettersDontMatch: (source: string, target: string) => source?.[0].toLowerCase() !== target?.[0].toLowerCase(),
    firstLetterToUpperRestToLower: (value: string): string => { return value[0].toUpperCase() + value.substring(1).toLowerCase() },
    areEqualToLower: (value1: string, value2: string) => value1.toLowerCase() === value2.toLowerCase()
};

export default stringHelper;
